import * as React from 'react'
import {ReactNode} from 'react'
import {connect} from 'react-redux'
import {Card, Col, Collapse, Container, Label, Row} from "reactstrap";
import {ApplicationState} from "src/store";
import {Product, ProductList} from "src/services/api";
import {WithTranslation, withTranslation} from "react-i18next";
import {selectedLang} from "App/helper";
import {Language, NATURAL_SORT_COMPARE_OPTIONS} from "App/constants";
import {ProductComponent} from "Components/ProductComponent";
import {Range} from "rc-slider";
import {changeSubCategoryPageFilter, extractNumber, Filter, toggleFilter} from "App/services/reducers/products";
import {List} from 'immutable';

interface StateToProps {
    catId: number | null
    subId: number | null
    products: ProductList | null
    filters: List<Filter>
    showFilters: boolean
}

const mapStateToProps = (state: ApplicationState): StateToProps => ({
    catId: state.data.subcategories?state.data.subcategories.catId:null,
    subId: state.data.products?state.data.products.subId:null,
    products: state.data.products?state.data.products.product:null,
    filters: state.data.products?state.data.products.filters:List<Filter>(),
    showFilters: state.data.products&&state.data.products.showFilters||false
});

interface DispatchToProps {
    onSliderChange: (id:number, value:[number, number]) => void
    onToggleFilter: () => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSliderChange: (id:number, value:[number, number]) => dispatch(changeSubCategoryPageFilter(id, value)),
    onToggleFilter: () => dispatch(toggleFilter())
});

interface StateToRangeProps {
    filter: Filter
    language: Language
    position: number
    onSliderChange: (id:number, value:[number, number]) => void
    onToggleFilter: () => void
}

class _Range extends React.Component<StateToRangeProps> {

    render() {
        const {filter, language, position, onSliderChange, onToggleFilter} = this.props;
        const value: [number, number] = [filter.actualMin, filter.actualMax];
        return (
            <Row className={"no-gutters pl-5 pr-4 pb-5 pb-sm-3"} key={filter.id}>
                <Col className={"col-11 col-sm-3 test-left text-sm-right pr-5 order-1"}>
                    <Label>{ filter.name[language]+" ("+filter.unit+")" }</Label>
                </Col>
                <Col className={"col-12 col-sm-8 px-2 order-3 order-sm-2"}>
                    <Range value={value} min={filter.min} max={filter.max} step={filter.step}
                           marks={{ [value[0]]: ""+value[0], [value[1]]: ""+value[1]}} allowCross={false}
                           onChange={(value:[number, number]) => onSliderChange(filter.id, value)}/>
                </Col>
                <Col className={"col-1 d-flex flex-column order-2 order-sm-3"}>
                    {position === 0 ?
                        <i className={"action fal fa-times align-self-end fa-lg"}
                           aria-hidden="true" onClick={() => onToggleFilter()}></i> : null
                    }
                </Col>
            </Row>
        );
    }
}

class _Container extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {

    filter(product:Product, filters:List<Filter>): boolean {
        return filters.every(f => {
            const value: number = extractNumber(product['maincharacteristic'+f.position+'value'])||Number.POSITIVE_INFINITY;
            return f.actualMin<=value && value<=f.actualMax;
        });
    }

    buildSlider(filter: Filter, position:number): ReactNode {
        const language: Language = selectedLang(this.props.i18n);
        return <_Range filter={filter} language={language} key={filter.id} onSliderChange={this.props.onSliderChange} onToggleFilter={this.props.onToggleFilter} position={position}/>;
    }

    render() {
        const {i18n, catId, subId, products, t, filters, showFilters} = this.props;
        const language: Language = selectedLang(i18n);
        return  <Container>
            <Collapse isOpen={showFilters}>
            {
                filters&&filters.size?
                    <Row className={"no-gutters pb-3 pt-1"}>
                        <Col>
                            <Card className={"pt-3 user-select-none"}>
                                {
                                    filters.map((filter:Filter, key:number) => this.buildSlider(filter, key))
                                }
                            </Card>
                        </Col>
                    </Row>:
                    null
            }
            </Collapse>
            <Row>
            {
                catId && subId?
                products&&products.length?
                    products
                        .filter(p => !showFilters||this.filter(p, filters))
                        .sort((i1:Product, i2:Product) => (i1.nameml[language]||'').localeCompare(i2.nameml[language]||'', undefined, NATURAL_SORT_COMPARE_OPTIONS))
                        .map((product: Product,index) => <ProductComponent key={product.id} className={"py-3 col-sm-6 col-md-4 col-lg-3"} product={product} catId={catId} subId={subId}/>)
                    :<Label>{ t('products.configuration.noproducts') }</Label>
                :null
            }
            </Row>
        </Container>
    }
}

export const SubCategoryPage = connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(_Container));


// WEBPACK FOOTER //
// ./src/containers/SubCategoryPage.tsx